import { useEffect, useState, useCallback, useRef } from 'react';
import consoleLogDev from './loggingHelper';

export default function useOverlayToggle() {
    const [showOverlay, setShowOverlay] = useState(false);

    const overlayRef = useRef(null);

    const toggleOverlay = useCallback(() => {
        setShowOverlay(show => !show);
    }, []);

    const onExternalElementClick = useCallback((event) => {
        if (overlayRef.current.contains(event.target)) {
            consoleLogDev('Clicked inside');
        } else {
            event.stopPropagation();
            setShowOverlay(false);
        }
    }, []);

    useEffect(() => {
        if (showOverlay && overlayRef.current) {
            document.body.addEventListener("click", onExternalElementClick, true);
        }

        return () => {
            if (showOverlay) {
                document.body.removeEventListener("click", onExternalElementClick, true);
            }
        }

    }, [showOverlay, onExternalElementClick]);

    return { showOverlay, toggleOverlay, overlayRef };
}